module.exports = __webpack_public_path__ + "static/media/dev.696cd9d6.svg";